module.exports = __webpack_public_path__ + "img/about-overlay.c4341188.png";